import { red } from "@material-ui/core/colors";
import { makeStyles } from "@material-ui/core/styles";
import BannerImage from "../../../assets/images/img-otros-plan.png";

const styles = makeStyles(theme => ({
  mainFaq: {
    backgroundColor: "#f4faff",
    [theme.breakpoints.down("xs")]: {
      paddingTop: "40px"
    }
  },
  titleSectionContainer: {
    padding: "60px 16% 45px 16%",
    [theme.breakpoints.down("md")]: {
      padding: "40px"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "0"
    }
  },
  titleContainer: {
    display: "flex",
    alignItems: "center"
  },
  titleSection: {
    fontSize: "42px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    fontFamily: "Trebuchet",
    lineHeight: "1.1",
    color: "rgba(0, 0, 0, 0.87)",
    maxWidth: "440px",
    marginBlockStart: "0em",
    marginBlockEnd: "0em",
    [theme.breakpoints.down("xs")]: {
      fontSize: "38px"
    }
  },

  lineTitle: {
    borderLeft: "10px solid #0073cf",
    height: "50px",
    marginRight: "15px"
  },
  draImageContainer: {
    paddingTop: "200px",
    paddingRight: "60px",
    display: "flex",
    [theme.breakpoints.down("md")]: {
      paddingTop: "50px",
      paddingRight: "0",
      display: "flex",
      justifyContent: "center"
    }
  },
  draImage: {
    width: "550px",
    height: "511px",
    alignSelf: "flex-end",
    [theme.breakpoints.down("lg")]: {
      width: "100%",
      height: "auto"
    },
    [theme.breakpoints.down("md")]: {
      maxWidth: 420
    },
    [theme.breakpoints.down("xs")]: {
      height: "auto"
    }
  },
  faqContainer: {
    padding: "20px 250px 0px 30px",
    [theme.breakpoints.down("md")]: {
      padding: "20px 40px 0px 40px"
    },
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column-reverse"
    },
    [theme.breakpoints.down("xs")]: {
      padding: "20px 10px 0px 10px"
    }
  }
}));

export default styles;
